import { Component, ViewContainerRef } from '@angular/core';
import * as $ from 'jquery';

import { GlobalState } from './global.state';
import { BaImageLoaderService, BaThemePreloader, BaThemeSpinner } from './theme/services';
import { BaThemeConfig } from './theme/theme.config';
import { layoutPaths } from './theme/theme.constants';

import {Router, NavigationStart} from '@angular/router';
import {LocalStorageService, SessionStorageService} from 'ngx-webstorage';

import {ResourcesService} from './theme/services/resources/resources.service';
import {EventsService} from './theme/services/events/events.service';

/*
 * App Component
 * Top Level Component
 */
@Component({
  selector: 'app',
  styleUrls: ['./app.component.scss'],
  template: `
    <simple-notifications [options]="options"></simple-notifications>
    <main [class.menu-collapsed]="isMenuCollapsed" baThemeRun>
      <div class="additional-bg"></div>
      <router-outlet></router-outlet>
    </main>
  `
})
export class App {

  public options = {
    position: ["top", "right"],
    timeOut: 3500,
    lastOnBottom: false,
    pauseOnHover: false,
    clickToClose: false,
    maxStack: 2,
    animate: "fromRight"
  }

  isMenuCollapsed: boolean = false;

  private subscribedNav;

  constructor(private _state: GlobalState,
              private _imageLoader: BaImageLoaderService,
              private _spinner: BaThemeSpinner,
              private viewContainerRef: ViewContainerRef,
              private themeConfig: BaThemeConfig,
              private _localStorage: LocalStorageService,
              private _sessionStorage: SessionStorageService,
              private _resourcesService:ResourcesService,
              private _eventsService: EventsService,
              private _router: Router) {

    themeConfig.config();

    this._loadImages();

    this._state.subscribe('menu.isCollapsed', (isCollapsed) => {
      this.isMenuCollapsed = isCollapsed;
    });

    this.subscribedNav = _router.events.subscribe(
                            (event) => this.checkNavigation(event)
                          );
  }

  private checkNavigation(event){
    var user = this._localStorage.retrieve('user_data');
    switch(event.url){
      case '/login':
        if(user!=null)
          this._router.navigateByUrl('/pages/home');
        break;
      default:
        if(user==null) {
          // Se guarda la URL pedida (por ejemplo, el link del mail) para volver después del login.
          if (event instanceof NavigationStart && App.urlRetornoValida(event.url))
            this._sessionStorage.store('url_retorno', event.url);
          this._router.navigateByUrl('/login');
        }
    }
  }

  public static urlRetornoValida(url: string): boolean {
    return typeof url === 'string' && url.indexOf('/pages/') === 0
      && url.indexOf('//') === -1 && url.indexOf('\\') === -1;
  }

  public ngAfterViewInit(): void {
    // hide spinner once all loaders are completed
    BaThemePreloader.load().then((values) => {
      this._spinner.hide();
    });
  }

  private _loadImages(): void {
    // register some loaders
    //BaThemePreloader.registerLoader(this._imageLoader.load('assets/img/sky-bg.jpg'));
  }

  ngOnDestroy() {
    this.subscribedNav.unsubscribe();
  }

}



// WEBPACK FOOTER //
// /app/src/app/app.component.ts